import { Back, gsap } from "gsap";
import { BitmapTextFieldProperties } from "../../game/control/properties/BitmapTextFieldProperties";
import { TextFieldProperties } from "../../game/control/properties/TextFieldProperties";
/**
 * TextUtil.ts
 */
export class TextUtil {
    static centreField(field) {
        field.pivot.set(0, field.getHeight() / 2);
    }
    static showField(field) {
        field.alpha = 0;
        field.scale.set(0, 0);
        gsap.to(field, { alpha: 1, duration: 0.25 });
        gsap.to(field.scale, { x: 1, y: 1, ease: Back.easeOut, duration: 0.5 });
        field.visible = true;
    }
    static hideField(field) {
        gsap.to(field, { alpha: 0, duration: 0.25 });
        gsap.to(field.scale, {
            x: 0,
            y: 0,
            ease: Back.easeOut,
            duration: 0.25,
            onComplete: this.resetField,
            callbackScope: this,
            onCompleteParams: [field],
        });
    }
    static resetField(field) {
        field.alpha = 1;
        field.scale.set(1);
        field.visible = false;
    }
    static fieldPropertiesEqual(a, b) {
        if (a instanceof BitmapTextFieldProperties) {
            if (b instanceof BitmapTextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        else if (a instanceof TextFieldProperties) {
            if (b instanceof TextFieldProperties) {
                return a.equals(b);
            }
            return false;
        }
        return a === b;
    }
}
//# sourceMappingURL=TextUtil.js.map